export function formatBytes(bytes: number, decimals?: number): string {
  if (bytes === 0) return '0 Bytes';
  const kilobyte = 1024;
  decimals = decimals || 2;
  const sizes: string[] = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const appropriateSize: number = Math.floor(Math.log(bytes) / Math.log(kilobyte));
  const formattedSize = parseFloat((bytes / Math.pow(kilobyte, appropriateSize)).toFixed(decimals));
  return `${formattedSize} ${sizes[appropriateSize]}`;
}
